module.exports = __webpack_public_path__ + "static/media/AW0081-54L_03.017e5811.png";